import React from 'react';
import { Route, withRouter } from 'react-router-dom';
export class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: null
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    onSubmit = (event) => {
        const { email, password } = this.state;
        
        this.props.firebase.auth.signInWithEmailAndPassword(email, password)
            .then((data) => {
                this.setState({ error: null });
                this.props.history.push({ pathname: '/group-adm', state: {isAuth:true} }
                );
            })
            .catch((error) => { console.log(error); this.setState({ error }); });

        event.preventDefault();
    };

    render() {
        const { email, password, error } = this.state;
        const isInvalid = email === '' || password === '';

        return (
            <form className="form-inline" onSubmit={this.onSubmit}>
                <div className="form-group mb-2">
                    <label className="sr-only">Email</label>
                    <input type="text" name="email" value={email} className="form-control"
                        onChange={this.onChange} />
                </div>
                <div className="form-group mx-sm-3 mb-2">
                    <label className="sr-only">Password</label>
                    <input type="password" name="password" value={password} className="form-control" placeholder="Password"
                        onChange={this.onChange} />
                </div>
                <button type="submit" className="btn btn-primary mb-2" disabled={isInvalid}>Confirm identity</button>
                {error && <p> {error.message}</p>}
            </form>
        );
    }
}